import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top on route change; scroll to anchor when a #hash is present
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      let attempts = 0;
      const tryScroll = () => {
        const el = document.getElementById(hash.slice(1));
        if (el) el.scrollIntoView({ block: "start" });
        else if (attempts++ < 25) setTimeout(tryScroll, 150);
      };
      setTimeout(tryScroll, 50);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
